import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Case2Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M24.75 6H23.375C23.0849 4.58927 22.3173 3.32168 21.2016 2.4109C20.0859 1.50011 18.6903 1.00182 17.25 1H14.75C13.3097 1.00182 11.9141 1.50011 10.7984 2.4109C9.68273 3.32168 8.91512 4.58927 8.625 6H7.25C5.59301 6.00198 4.00445 6.6611 2.83278 7.83278C1.6611 9.00445 1.00199 10.593 1 12.25V16H31V12.25C30.998 10.593 30.3389 9.00445 29.1672 7.83278C27.9956 6.6611 26.407 6.00198 24.75 6ZM11.23 6C11.4876 5.27136 11.964 4.64011 12.5941 4.19261C13.2242 3.7451 13.9772 3.5032 14.75 3.5H17.25C18.0228 3.5032 18.7758 3.7451 19.4059 4.19261C20.036 4.64011 20.5124 5.27136 20.77 6H11.23Z"
        fill="currentColor"
      />
      <path
        d="M17.25 19.75C17.25 20.0815 17.1183 20.3995 16.8839 20.6339C16.6495 20.8683 16.3315 21 16 21C15.6685 21 15.3505 20.8683 15.1161 20.6339C14.8817 20.3995 14.75 20.0815 14.75 19.75V18.5H1V24.75C1.00198 26.407 1.6611 27.9956 2.83277 29.1672C4.00445 30.3389 5.59301 30.998 7.25 31H24.75C26.407 30.998 27.9956 30.3389 29.1672 29.1672C30.3389 27.9956 30.998 26.407 31 24.75V18.5H17.25V19.75Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
